import "F:\\web_project\\sc_qing_zhinengshenhe\\\u89C6\u9891\u5DE5\u5177\\public-video-tools-git\\node_modules\\core-js\\modules\\es6.array.iterator.js";
import "F:\\web_project\\sc_qing_zhinengshenhe\\\u89C6\u9891\u5DE5\u5177\\public-video-tools-git\\node_modules\\core-js\\modules\\es6.promise.js";
import "F:\\web_project\\sc_qing_zhinengshenhe\\\u89C6\u9891\u5DE5\u5177\\public-video-tools-git\\node_modules\\core-js\\modules\\es6.object.assign.js";
import "F:\\web_project\\sc_qing_zhinengshenhe\\\u89C6\u9891\u5DE5\u5177\\public-video-tools-git\\node_modules\\core-js\\modules\\es7.promise.finally.js";
import Vue from 'vue';
import 'normalize.css/normalize.css'; // A modern alternative to CSS resets

import ElementUI from 'element-ui';
import '@/styles/index.scss'; // global css

import App from "./App";
import store from "./store";
import router from "./router";
import '@/icons'; // icon
import '@/permission'; // permission control

Vue.use(ElementUI);
// 设置全局默认属性
var defaultSize = 'small';
ElementUI.Button.props.size.default = defaultSize;
ElementUI.Form.props.size.default = defaultSize;
Vue.prototype.msgSuccess = function (msg) {
  this.$message({
    showClose: true,
    message: msg,
    type: 'success'
  });
};
Vue.prototype.msgError = function (msg) {
  this.$message({
    showClose: true,
    message: msg,
    type: 'error'
  });
};

// 全局方法挂载
import { goToWithQuery, goBack } from '@/utils/jump';
Vue.prototype.goToWithQuery = goToWithQuery;
Vue.prototype.goBack = goBack;

// import JsonViewer from 'vue-json-viewer'
// Vue.use(JsonViewer)

Vue.config.productionTip = false;
new Vue({
  el: '#app',
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
});